import axios from './axios';

export default {
  get: async params => {
    const { data } = await axios.get('/subscriptions', { params });
    return data;
  }
};
